import Keycloak from 'keycloak-js';

import { KEYCLOAK_CLIENT_ID, KEYCLOAK_REALM, KEYCLOAK_URL } from '@/shared/constant/api';

export type AuthProviderType = 'password' | 'sso';

const AUTH_PROVIDER_STORAGE_KEY = 'auth_provider';

export const getAuthProvider = () =>
	localStorage.getItem(AUTH_PROVIDER_STORAGE_KEY) as AuthProviderType | null;

export const setAuthProvider = (provider: AuthProviderType) =>
	localStorage.setItem(AUTH_PROVIDER_STORAGE_KEY, provider);

export const clearAuthProvider = () => localStorage.removeItem(AUTH_PROVIDER_STORAGE_KEY);

export const isKeycloakConfigured = () =>
	Boolean(KEYCLOAK_URL && KEYCLOAK_REALM && KEYCLOAK_CLIENT_ID);

export const createKeycloakClient = () =>
	new Keycloak({
		url: KEYCLOAK_URL,
		realm: KEYCLOAK_REALM,
		clientId: KEYCLOAK_CLIENT_ID,
	});

// SSO-сессия хранится в формате ответа federation-сервиса
export const buildSSOSession = <
	T extends {
		access_token: string;
		access_expires_at: Date;
		update_expires_at: Date;
		access_expired: boolean;
	},
>(
	user: T,
	keycloakAccessToken: string,
	keycloakExp?: number,
): T => {
	const expiresAt = keycloakExp
		? new Date(keycloakExp * 1000).toISOString()
		: new Date(Date.now() + 60 * 1000).toISOString();

	return {
		...user,
		access_token: keycloakAccessToken,
		access_expires_at: expiresAt as unknown as Date,
		update_expires_at: expiresAt as unknown as Date,
		access_expired: false,
	};
};
